export const arrayWithItemFirst =
  <T>(data: T[]) =>
  (first: T): T[] =>
    data.includes(first) ? [first, ...data.filter((element) => element !== first)] : data
